"use client";

import { useInspectorMode } from "@utils/ContentfulUtils";
import Image from "next/image";
import React, { useContext, useEffect, useRef, useState } from "react";

// import { NavigationContext } from "@/context/NavigationContext";
import { SearchContext } from "@/context/SearchContext";
import useBreakPoint from "@/hooks/useBreakpoint";
import { useOutsideClick } from "@/hooks/useOutsideClick";
import { BaseEntry, Media, SearchParams, VISUAL_VARIANT } from "@/types";

export interface HeroFirstCard extends BaseEntry {
  video: Media;
  video_mobile?: Media;
  backupVideoImage: Media;
  logo?: Media;
}

interface Props {
  entry: HeroFirstCard;
}

export default function HeroFirstCard({ entry }: Props) {
  const inspectorMode = useInspectorMode(entry.id);
  const videoRef = useRef<HTMLVideoElement>(null);
  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.muted = true;
      videoRef.current.defaultMuted = true;
      videoRef.current.playsInline = true;

      // Play the video manually if autoplay fails
      const playPromise = videoRef.current.play();
      if (playPromise !== undefined) {
        playPromise.catch((error) => {
          console.warn("Autoplay failed:", error);
        });
      }
    }
  }, []);
  return (
    <div className="relative flex justify-center h-svh" {...inspectorMode.getProps("video")}>
      <div className="absolute z-10 w-full h-full img-overlay-homepage-hero"></div>
      <video className="videoHero" poster={entry.backupVideoImage.url} autoPlay loop muted playsInline ref={videoRef}>
        <source media={entry.video_mobile ? "all and (orientation: landscape)" : undefined} src={entry.video.url} type="video/mp4" />
        {entry.video_mobile && <source media="all and (orientation: portrait)" src={entry.video_mobile.url} type="video/mp4" />}
      </video>
      {entry.logo && (
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 mb-xl">
          <div className="flex-col items-center hidden md:flex">
            <Image src={entry.logo.url} alt={entry.logo.title} width={310} height={157} />
          </div>
          <div className="flex flex-col items-center md:hidden">
            <Image src={entry.logo.url} alt={entry.logo.title} width={177} height={90} />
          </div>
        </div>
      )}
    </div>
  );
}
